import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { calculatePaymentsTotal } from "../utils";
import { useRelatedRecords } from "../../../api/useRelatedRecords";
import { PaymentsHeader } from "./PaymentsHeader";
import { PaymentRow } from "./PaymentRow";
import { PaymentBankTransactionCell } from "./PaymentBankTransactionCell";

type ReadOnlyOrderPaymentsProps = {
    orderId?: number;
    orderTotal: number;
    paymentMethodField: any;
    amountField: any;
};

export const ReadOnlyOrderPayments = ({
    orderId,
    orderTotal,
    paymentMethodField,
    amountField,
}: ReadOnlyOrderPaymentsProps) => {
    const relatedPayments = useRelatedRecords("orders_payments", "*,connected_bank_transaction_id.*", "order", orderId);
    const payments = relatedPayments.data?.items || [];
    const paymentsTotal = calculatePaymentsTotal(payments);
    const choices = paymentMethodField.settings?.options?.choices || [];

    return (
        <Box mt={3} ml={0.5} p={2} sx={{ backgroundColor: "#fff" }}>
            <PaymentsHeader paymentsTotal={paymentsTotal} orderTotal={orderTotal} showAddButton={false} />

            {payments.length > 0 ? (
                <TableContainer component={Paper}>
                    <Table sx={{ tableLayout: 'fixed' }}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ width: '15%' }}>Data</TableCell>
                                <TableCell sx={{ width: '20%' }}>Método de Pagamento</TableCell>
                                <TableCell sx={{ width: '15%' }}>Valor</TableCell>
                                <TableCell sx={{ width: '50%' }}>Transação Bancária</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {payments.map((payment: any) => (
                                <PaymentRow
                                    key={payment.id}
                                    payment={payment}
                                    index={0}
                                    paymentMethodField={paymentMethodField}
                                    amountField={amountField}
                                    choices={choices}
                                    isReadOnly={true}
                                    bankTransactionCell={
                                        <PaymentBankTransactionCell
                                            paymentId={payment.id}
                                            connectedBankTransaction={payment.connected_bank_transaction_id}
                                            onAssociationChange={() => relatedPayments.refetch()}
                                        />
                                    }
                                />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            ) : (
                <Box py={4} display="flex" justifyContent="center">
                    <Typography color="text.secondary">Ainda não existem gerados para esta compra</Typography>
                </Box>
            )}
        </Box>
    );
};

